import store from '../config.js'
import containerItem from "../type/item/container.js"
import * as namespaceStore from "../namespaceStore.js"
import GeneralClassMethod from "../generalClassMethod.js"

const basePage = class extends GeneralClassMethod {
    Name = "Page";
    constructor(args = {}) {
        super();
    }
    static get _Compositions() {
        return null;
    }
    get Composition() {
        if (this.constructor._Compositions) {
            return store.getters[namespaceStore.THEME + "/compositions"];
        }
        return null;
    }
    get playAnimationDeep() {
        return undefined;
    }
    set playAnimationDeep(value) {
        for (const el of this.constructor.variableOfInstance()) {
            if (el.jsType == "Class" && this[el.property] != null) {
                this[el.property].playAnimationDeep = value;
            }
            else if (el.jsType == "Array" && this[el.property] != null) {
                for (const element of this[el.property]) {
                    if (typeof element === 'object' && !Array.isArray(element) && element !== null) {
                        element.playAnimationDeep = value;
                    }
                }
            }
        }
    }
    checkIsComplete(result = {isComplete: true, requiredBeforeSave: false, missingElements: []}) {
        return result;
    }
    CompositionPreviewId(elementAdd) {
        if (this.constructor._Compositions) {
            if (this.constructor._Compositions.jsType == "Array" && elementAdd[this.constructor._Compositions.property].length > 0) {
                return elementAdd[this.constructor._Compositions.property][0].previewId;
            }
            else if (this.constructor._Compositions.jsType == "Class") {
                return elementAdd[this.constructor._Compositions.property].previewId;
            }
        }
        return null;
    }
    get CompositionElement() {
        if (this.constructor._Compositions) {
            return store.getters[namespaceStore.THEME + "/compositionsElement"](this.constructor._Compositions.property);
        }
        return null;
    }
    static variableOfInstance() {
         if (this._Compositions) {
            return [
                {property: "CompositionElement", construct: containerItem, jsType: "Array", compositionElementName: this._Compositions.property}
            ]
        }
        return [];
    }
    onShow() {
        return null;
    }
    swapArrayElement(property, index, move) {
        if (index < 0 || index > this[property.name].length) return;
        this[property.name].splice(index + move, 0, this[property.name].splice(index, 1)[0]);
    }
    static fromObject(object = {}) {
        let elementForConstruct = {};
        const instanceVariables = this.variableOfInstance();
        instanceVariables.forEach(el => {
            const objName = this.nameFormater(el.property);
            if (object[objName]) {
                if (el.jsType == "Array")
                    elementForConstruct[objName] = object[objName].map(elToCreate => el.construct.fromObject(elToCreate));
                else if (el.jsType == "Class")
                    elementForConstruct[objName] = el.construct.fromObject(object[objName]);
                else
                    elementForConstruct[objName] = new el.construct(object[objName]);
            }
        });
        return new this(elementForConstruct);
    }
    fromObject(object = {}) {
        this.constructor.variableOfInstance().forEach(el => {
            if (el.property == "CompositionElement") return;//ignore composition elements
            const objName = this.constructor.nameFormater(el.property);
            if (el.jsType == "Array")
                this[el.property] = object[objName] ? object[objName].map(e => el.construct.fromObject(e)) : [];
            else if (el.jsType == "Class")
                this[el.property] = object[objName] ? el.construct.fromObject(object[objName]) : null;
            else
                this[el.property] = object[objName]
        })
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        let objectRet = {};
        this.constructor.variableOfInstance().forEach(el => {
            let objName = this.constructor.nameFormater(el.property);
            if (el.property == "CompositionElement") {
                objName = this.constructor.nameFormater(el.compositionElementName);
                // return;//ignore composition elements
            }
            if (el.specialFunctionExport) {
                objectRet[objName] = this[el.specialFunctionExport](variableArray, ressourceArray);
            }
            else if (el.jsType == "Array")
                objectRet[objName] = this[el.property].length > 0 ? this[el.property].map(e => e.toExportObject(variableArray, ressourceArray)) : [];
            else if (el.jsType == "Class") {
                objectRet[objName] = this[el.property] ? this[el.property].toExportObject(variableArray, ressourceArray) : null;
            }
            else
                objectRet[objName] = this[el.property]
        });
        return objectRet;
    }
    toObject(minify = false) {
        let objectRet = {};
        this.constructor.variableOfInstance().forEach(el => {
            if (el.minify === false && minify == true) return;
            if (el.property == "CompositionElement") return;//ignore composition elements
            const objName = this.constructor.nameFormater(el.property);
            if (el.jsType == "Array")
                objectRet[objName] = this[el.property].length > 0 ? this[el.property].map(e => e.toObject()) : [];
            else if (el.jsType == "Class") {
                objectRet[objName] = this[el.property] ? this[el.property].toObject() : null;
            }
            else
                objectRet[objName] = this[el.property]
        });
        return objectRet;
    }
    removeBaseElement(previewId) {
        this.constructor.variableOfInstance().some(el => {
            const objName = this.constructor.nameFormater(el.property);
            if (el.jsType == "Array") {
                const found = this[el.property].findIndex(e => e.previewId == previewId);
                if (found != -1) {
                    this[el.property].splice(found, 1);
                    return true;
                }
            }
            else if (el.jsType == "Class") {
                if (this[el.property] != null && this[el.property].previewId == previewId) {
                    this[el.property] = null;
                    return true;
                }
            }
            return false;
        });
    }
    toIterable() {
        let iterable = [];
        this.constructor.variableOfInstance().forEach(el => {
            const objName = this.constructor.nameFormater(el.property);
            if (el.jsType == "Array" && this[el.property].length > 0)
                Array.prototype.push.apply(iterable, this[el.property]);
            else if (el.jsType == "Class" && this[el.property] != null)
                iterable.push(this[el.property]);
        });
        return iterable;
    }
    getPropertiesDescription() {
        return [];
    }
    getCompositionsDescription() {
        if (this.constructor._Compositions) {
            return [
                { name: "CompositionElement", ...this.constructor._Compositions },
            ];
        }
        return [];
    }
}
export default basePage;
